

export function saveStateToLocalStore(param, value) {
    //move to local storage
    window.localStorage.setItem('userSearch', true);
    var payloadString = window.localStorage.getItem('userPayload');
    var payload = payloadString != null ? JSON.parse(payloadString) : {};

    var newPayload = { ...payload, [param]: value };
    window.localStorage.setItem('userPayload', JSON.stringify(newPayload));

  }
export function resetLocalStore() {
    // var payloadString = window.localStorage.getItem("userPayload");

    // if (payloadString !== null) {
    //   var payload = JSON.parse(payloadString);
    //   var newPayload = {
    //     ...payload,
    //     hours: undefined,
    //     radius: undefined,
    //     meta: undefined
    //   }
    // }
    window.localStorage.setItem('payload', {})
  }
export function setStateFromLocalStore(self) {
    
    var isUserSearch = window.localStorage.getItem('userSearch');
    if (isUserSearch === null || isUserSearch === 'false') {
      return;
    }

    var payloadString = window.localStorage.getItem("userPayload");
    if (payloadString !== null) {
      var payload = JSON.parse(payloadString);

      if (payload.term !== undefined) {
        // For Google Maps PlaceAutocompleteElement, set the value on the input element
        let input = null;
        if (self.$refs && self.$refs.place) {
          input = self.$refs.place;
        } else if (self.$refs && self.$refs.autocompleteContainer) {
          // Try to find the input inside the autocomplete container
          input = self.$refs.autocompleteContainer.querySelector('input');
        }
        if (input) {
          input.value = payload.term;
        }
        
        // Also update Vue's reactive data property
        if (self.searchTerm !== undefined) {
          self.searchTerm = payload.term;
        }
        
        const searchEl = document.getElementsByClassName("location-search-container__search");
        if(searchEl && searchEl[0]) {
            searchEl[0].classList.add('is-floating');
        }
      }

      if (payload.lat !== undefined && payload.lng !== undefined) {

        self.lat = +payload.lat;
        self.lng = +payload.lng; 
        
        
      }

      //triggerDistanceFilter
      if (payload.radius !== undefined) {
        self.distance = payload.radius;
      }

      
        //triggerMetaFilter
      if (payload.services !== undefined) {
        self.meta = payload.services;
      }

      //triggerHoursFilter  
      if (payload.hours !== undefined) {
        self.hours = payload.hours;          
      }
      
      self.updateLocations(payload);
      self.updateFilters(payload);
    }

  }